<template>
  <div>
    <div class="father_div container-fluid">
      <div class="row row-no-gutters">
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <div class="left_div">
            <div class="left_div_top">
              <div style="height: 100%">
                <p class="heading">提供一站式膳食经营管理餐饮服务</p>
                <p class="sub_heading">解决企业后勤人力问题</p>
                <div class="tv_content">
                  <p>
百康源餐饮管理有限公司秉承创新美食文化的理念，严格坚守食品健康安全，严苛遵循HACCP管理体系规范操作，为广大企事业单位员工提供丰富健康营养的膳食和细致周到的服务。
                  </p>
                  <p>一站式膳食经营管理餐饮服务提高了员工就餐体验，改善员工福利及提高企业员工归属感。同时，简化了企事业单位的工作章程，协助企业控制成本，解决企业发展的后勤瓶颈问题，助力企业更高效的投入到运营管理中去。
                  </p>
                </div>
                <div class="litter_line"></div>
              </div>
            </div>
            <div class="left_div_bottom">
              <img src="../../../static/img/切片-44.jpeg" />
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <div class="right_div">
            <div class="right_div_top">
              <div class="row row-no-gutters" style="height: 100%">
                <div class="col-xs-5 col-sm-5 col-md-5 col-lg-5">
                  <div class="right_div_top_left">
                    <img
                      class="right_div_top_lefttop"
                      src="../../../static/img/切片-47.jpg"
                    />
                    <img
                      class="right_div_top_leftbottom"
                      src="../../../static/img/切片-46.jpg"
                    />
                  </div>
                </div>
                <div class="col-xs-7 col-sm-7 col-md-7 col-lg-7">
                  <div class="right_div_top_right">
                    <img src="../../../static/img/切片-48.jpg" />
                  </div>
                </div>
              </div>
            </div>
            <div class="right_div_bottom">
              <img src="../../../static/img/切片-45.jpg" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ShowLine from "../../components/ShowLine.vue";
export default {
  components: {
    ShowLine,
  },
  data() {
    return {};
  },
  mounted() {
    this.Init();
  },
  destroyed() {},
  deactivated() {
    this.$destroy();
  },
  watch: {
    //监听路由变化
    $route(to, from) {
      this.Init();
    },
  },
  methods: {
    Init() {},
    navto(path) {
      // $(".collapse.in").removeClass("in");
      this.$router.push(path);
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    handleScroll() {
      $(".num").waypoint(
        () => {
          this.$refs.mynum1.start();
        },
        {
          offset: "80%",
        }
      );
      $(".mynum").waypoint(
        () => {
          this.$refs.mynum.start();
        },
        {
          offset: "80%",
        }
      );
    },
  },
};
</script>

<style lang="stylus" scoped>
.father_div {
  width: 80%;
  margin: auto;
  padding: 10vw 0;
}

.bottommenu {
  background-color: #545c64;
}

.el-menu-demo {
  margin-top: 3px;
}

.elcol {
  padding: 0;
  height: 100%;
}

.heading {
  margin: 0;
  font-size: 4.8rem;
  color: var(--textBlue);
  text-align: left;
  font-family: bold;
}

.litter_line {
  box-sizing: border-box;
  background-color: black;
  height: 1px;
  width: 100%;
  position: absolute;
  bottom: 0;
  margin-bottom: 1rem;
}

.sub_heading {
  margin: 5rem 0;
  font-size: 3rem;
  color: var(--textBlue);
  text-align: left;
  font-family: regular;
}

.tv_content {
  position: absolute;
  bottom: 10rem;
  box-sizing: border-box;
  height: auto;
  padding-top: 5rem;
  font-size: 1.4rem;
  color: #4c4948;
  text-align: left;
  line-height: 2.5rem;
  display: block;
  font-family: light;
}

.left_div {
  height: 100%;
}

.left_div_top {
  height: 50rem;
  width: 100%;
  display: block;
  position: relative;
}

.left_div_bottom {
  height: 55rem;

  img {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.right_div {
  padding-left: 1rem;
  height: 100%;
  width: 100%;
}

.right_div_top {
  width: 100%;
  height: 77rem;

  .right_div_top_left {
    height: 77rem;
    width: 100%;

    img {
      display: block;
      margin-left: auto;
      margin-right: auto;
      width: 100%;
      object-fit: cover;
      height: 100%;
      box-sizing: border-box;
    }
  }

  .right_div_top_lefttop {
    height: 65% !important;
    padding-bottom: 1rem;

    img {
      display: block;
      margin-left: auto;
      margin-right: auto;
      width: 100%;
      object-fit: cover;
      height: 100%;
      box-sizing: border-box;
    }
  }

  .right_div_top_leftbottom {
    height: 35% !important;

    img {
      display: block;
      margin-left: auto;
      margin-right: auto;
      width: 100%;
      object-fit: cover;
      height: 100%;
    }
  }

  .right_div_top_right {
    padding-left: 1rem;
    height: 77rem;
    width: 100%;

    img {
      width: 100%;
      object-fit: cover;
      height: 100%;
    }
  }
}

.right_div_bottom {
  height: 28rem;
  width: 100%;
  box-sizing: border-box;
  padding-top: 1rem;

  img {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    height: 100%;
  }
}

@media screen and (min-width: 2000px) {
  .father_div {
    width: 60%;
  }

  .sub_heading {
    margin: 5rem 0;
  }

  .tv_content {
    position: absolute;
    bottom: 10rem;
  }

  .left_div_top {
    height: 50rem;
  }

  .left_div_bottom {
    height: 57rem;
  }

  .right_div_top {
    height: 77rem;

    .right_div_top_left {
      height: 77rem;
    }

    .right_div_top_right {
      height: 77rem;
    }
  }

  .right_div_bottom {
    height: 30rem;
  }
}

@media screen and (max-width: 800px) {
  .heading {
  font-size: 3rem;
}

.sub_heading {
  margin: 3rem 0;
  font-size: 2rem;
}
  .father_div {
    width: 90%;
  }

  .tv_content {
    bottom: 0;
  }

  .right_div {
    padding-left: 0;
    height: 100%;
    width: 100%;
  }

  .left_div_top {
    height: 43rem;
  }

  .left_div_bottom {
    height: 20rem;
  }

  .right_div_top {
    margin-top: 1rem;
    height: 40rem;

    .right_div_top_left {
      height: 40rem;
    }

    .right_div_top_right {
      height: 40rem;
    }
  }

  .right_div_bottom {
    height: 20rem;
  }
}
</style>
